// import _http from "../axiosFlotex";
import jwt from '../jwt'
import store from '@/store/store'

// Dedykowana instacja axios dla auth z własnymi interceptorami.
import axios from 'axios'

const _http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Accept: 'application/ld+json',
    'Content-Type': 'application/ld+json'
  }
})

// --------------------------------------
// Pobieraj i wysyłaj ciasteczka
const crossOriginCookie = true

function setTokenFromResponse(response) {
  jwt.set(response.data.token)
  // jwt.setRefreshExpire(response.data.data.refresh_token_expires_at)

  // Token not set, data invalid
  if (!jwt.getToken()) {
    return new Promise((resolve, reject) => {
      reject(response)
    })
  }

  return jwt.getToken()
}

export default {
  login(username, password) {
    // If token already set, don't do anything
    if (jwt.isValid()) {
      return Promise.resolve(jwt.getToken())
    }

    // Not token available, authenticate
    let data = {
      username,
      password
    }
    return _http({
      url: 'login_check',
      method: 'post',
      data,
      withCredentials: crossOriginCookie // Pobierz ciasteczka, wystawione przez serwer w czasie logowania.
    })
      .then((response) => {
        // console.log(response.data)
        setTokenFromResponse(response)

        return response
      })
      .catch((error) => {
        // console.log(['auth.js', error.isAxiosError, error.message, error, error.response]);

        if (error.isAxiosError && 'Network Error' === error.message) {
          store.set('error/errorNetwork', true)
        }

        // Prawdopodobnie problem z dostępem do bazy danych
        if (
          error.isAxiosError &&
          error.response &&
          error.response.status === 401
        ) {
          store.set('error/error5xx', true)
        }

        if (
          error.isAxiosError &&
          error.response &&
          error.response.status >= 500
        ) {
          store.set('error/error5xx', true)
        }
      })
  }
  // ,
  // refresh() {
  //   return _http({
  //     url: 'refresh_token',
  //     method: 'post',
  //     withCredentials: crossOriginCookie // Wyślij ciasteczka, certyfikaty itp.
  //   }).then((response) => {
  //     // console.log(response.data)
  //     setTokenFromResponse(response)

  //     return response
  //   })
  // }
}
